import React, {Component} from 'react';
import produce from 'immer';
import withLifecycles from 'async-lifecycles';
import {Button, Form} from 'semantic-ui-react';
import {Link} from 'react-router-dom';
import toastr from 'toastr';
import {connect} from 'react-redux';
import includes from 'lodash/includes';

import {ROLES} from '../../constants';
import userApi from '../../store/services/users';
import FormContainer from '../form-components/FormContainer';
import UserForm from './UserForm';
import {ErrorMessages} from '../form-components/ErrorMessages';

class NewUserScreen extends Component {
  state = {
    loading: false,
    user: {
      customerId: undefined,
      firstName: '',
      lastName: '',
      emailAddress: '',
      role: '',
      company: '',
      title: '',
      phoneNumber: '',
    },
    error: {},
  };

  _mutate = cb => {
    this.setState(produce(cb));
  };

  _handleTextChanged = (event, {name, value}) => {
    const shouldClearCustomer = !includes(
      [ROLES.CUSTOMER_ADMIN, ROLES.CUSTOMER_USER],
      value
    );

    this._mutate(draft => {
      draft.user[name] = value;

      if (name === 'role' && shouldClearCustomer) {
        draft.user.customerId = undefined;
      }
    });
  };

  _save = () => {
    withLifecycles(
      () => userApi.create(this.state.user),
      ({loading, data, error}) => {
        this._mutate(draft => {
          draft.loading = loading;
          draft.error = error;

          if (data && !data.hasErrors) {
            this.props.history.push('/manage/users');
            toastr.success('User Created');
          }
        });
      }
    );
  };

  render() {
    const {error, loading, user} = this.state;
    const customerOptions = this.props.customers.map(x => ({
      text: x.name,
      value: x.id,
    }));

    return (
      <FormContainer loading={loading}>
        <Form onSubmit={this._save}>
          <UserForm
            user={user}
            role={this.props.role}
            customerOptions={customerOptions}
            handleTextChanged={this._handleTextChanged}
          />
          <ErrorMessages error={error} />
          <Button type="Submit" primary>
            Add
          </Button>
          <Button basic as={Link} to="/manage/users">
            Cancel
          </Button>
        </Form>
      </FormContainer>
    );
  }
}

const mapStateToProps = ({customers, identity}) => ({
  customers: customers.data,
  role: identity.user.role,
});

export default connect(mapStateToProps)(NewUserScreen);
